import { isSyntheticTrainingTenant } from './syntheticTraining';

export const FINANCIAL_REPORTS_DEMO_TENANT = '3ZBRXVlW2uz4VBIdG7aD';
export const FINANCIAL_REPORTS_MERCURY_TENANT = '1KAV4fFiYOc3dPNCwzeT';
// Explicit account rollout; the company service independently enforces eligibility.
export const isFinancialReportsDemoEnabled = tenantId => tenantId === FINANCIAL_REPORTS_DEMO_TENANT || tenantId === FINANCIAL_REPORTS_MERCURY_TENANT || isSyntheticTrainingTenant(tenantId);
export const isFinancialAnalysisWorkspaceTenant = tenantId => tenantId === FINANCIAL_REPORTS_MERCURY_TENANT;
